import { SVGProps } from "react";

export const Info = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" />
    <path
      fill="currentColor"
      d="M10 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9 9h2v7H9V9Z"
    />
  </svg>
);
